// extracted by mini-css-extract-plugin
export default {"aboutSection":"About_aboutSection__PluZl"};